module.exports = __webpack_public_path__ + "static/media/downloads-poster.c297536d.png";